import { render } from "./ResourceIndexPage.vue?vue&type=template&id=9d33ff26"
import script from "./ResourceIndexPage.vue?vue&type=script&lang=js"
export * from "./ResourceIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__